import React from 'react';
import { Subtext } from '@ui-library/typography';
import { Link } from '../styles';

interface IProps {
  goToTeammates: () => void;
}

const InviteTeamMembers = ({ goToTeammates }: IProps) => (
  <Subtext>
    Don’t have access to code?
    <Link onClick={goToTeammates}> Invite a team member!</Link>
  </Subtext>
);

export default InviteTeamMembers;
